export default "__VITE_ASSET__34372703__"